import { Attr, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

@Model()
class BlueskyProfile extends ApplicationRecord {
  static jsonapiType = "bluesky_profiles";

  @Attr() did: string;

  @Attr() handle: string;

  @Attr() displayName: string;

  @Attr() description: string;

  @Attr() avatarUrl: string;

  @Attr() bannerUrl: string;

  @Attr() followersCount: number;

  @Attr() followsCount: number;

  @Attr() postsCount: number;

  @Attr() processing: boolean;

  @Attr() categoryId: number;

  @Attr({ persist: false }) createdAt: string;

  @Attr({ persist: false }) updatedAt: string;
}

export default BlueskyProfile;
